module.exports = __webpack_public_path__ + "img/mongo.c869eb5d.svg";